import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/skeleton';

export const TurnAnswerSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="turn-card flex flex-col items-start gap-2 self-stretch" aria-busy>
      <span className="sr-only">{t('try_it.processing_request')}</span>
      <Skeleton className="h-4 w-40" />
      <div className="flex w-full flex-col gap-2">
        <Skeleton className="h-3 w-4/5" />
        <Skeleton className="h-3 w-3/5" />
      </div>
    </div>
  );
};
